import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { IPayload } from 'Model/IPayload';
import { API_URL, apiMethod, apiType } from 'utils';
import { 
    GET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID, 
    GET_CATALOG_MANAGEMENT_GRID_COUNT, 
    GET_CATALOG_MANAGEMENT_GRID_DATA, 
    GET_CATALOG_STATUS_DROPDOWN, 
    GET_DRIVE_TRAIN_DROPDOWN, 
    GET_EQ_CLASS_CODE_DROPDOWN, 
    GET_FUEL_TYPE_DROPDOWN, 
    GET_MAKE_DROPDOWN, 
    GET_MODEL_DROPDOWN_LIST, 
    GET_MODEL_YEAR_DROPDOWN, 
    GET_UPDATED_BY_DROPDOWN_LIST, 
    GET_UPFIT_OPTION_DROPDOWN, 
    GET_VEHICLE_TYPE_DROPDOWN_LIST, 
    GET_CATALOG_EQUIPMENT_GRID_DATA, 
    GET_CATEGORY_DROPDOWN_LIST, 
    GET_LENGTH_DROPDOWN_LIST, 
    GET_MANUFACTURER_DROPDOWN_LIST, 
    GET_SEATING_CAPACITY_DROPDOWN_LIST, 
    GET_MODELS_BASED_ON_MAKE, 
    SAVE_CATALOG_ITEM,
    GET_CATALOG_ITEM_BY_ASSET_MODEL_ID,
    GET_EQUIPMENT_MODELS_BASED_ON_MAKE,
    GET_CATEGORY2_BASED_ON_CATEGORY,
    GET_CATEGORY_TYPE_BASED_ON_CATEGORY, 
    GET_CATALOG_DASHBOARD_EXCEL_DATA,
    VALIDATE_SELECTED_VEHICLE_LEVELS,
    GET_ASSET_TYPE_OPTIONS,
    GET_EQ_CLASS_CODE_EXAMPLE
} from 'Store/Component/CatalogManagement/CatalogManagementType';
import { 
    setAllDropdownBySubTypeId, 
    setCatalogManagementGridCount, 
    setCatalogManagementGridData, 
    setCatalogStatusDropdown, 
    setDriveTrainDropdown, 
    setEqClassCodeDropdown, 
    setFuelTypeDropdown, 
    setMakeDropdown, 
    setModelDropdownList, 
    setModelYearDropdown, 
    setUpdatedByDropdownList, 
    setUpfitOptionDropdown, 
    setVehicleTypeDropdownList, 
    setCatalogEquipmentGridData, 
    setCategoryDropdownList, 
    setLengthDropdownList, 
    setManufacturerDropdownList, 
    setSeatingCapacityDropdownList, 
    setModelsBasedOnMake, 
    setIsCatalogItemSaved,
    setCatalogItemByAssetModelId,
    setCategory2BasedOnCategory,
    setCategoryTypeBasedOnCategory, 
    setCatalogDashboardExcelData,
    setIsSelectedVehicleLevelValid,
    setAssetTypeOption,
    setEqClassCodeExample
} from 'Store/Component/CatalogManagement/CatalogManagementAction';
import AssetManagementApiService from 'Service/AssetManagement/AssetManagementApiService';
import { AttributeName } from 'client/utils/constants';

function* getCatalogManagementGridCount(): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/catalog/count`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData);
        yield put(setCatalogManagementGridCount(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogManagementGridCount([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogManagementGridData(payload: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/catalog/vehicle`,
            apiMethod : apiMethod.POST,
            payload : payload?.payload
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setCatalogManagementGridData(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogManagementGridData([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogEquipmentGridData(payload: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/catalog/managedequipment`,
            apiMethod : apiMethod.POST,
            payload : payload?.payload
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setCatalogEquipmentGridData(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogEquipmentGridData([]))
        yield put(globalLoaderText(""));
    }
}

function* getUpfitOptionDropdown(): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/upfitoption`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setUpfitOptionDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUpfitOptionDropdown([]))
        yield put(globalLoaderText(""));
    }
}

function* getMakeDropdown(): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/vehicle/make`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setMakeDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setMakeDropdown([]))
        yield put(globalLoaderText(""));
    }
}

function* getModelDropdownList(vehicleType:any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/filter/model/${vehicleType.vehicleType}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setModelDropdownList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setModelDropdownList([]))
        yield put(globalLoaderText(""));
    }
}

function* getFuelTypeDropdown(vehicleType: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/fuelType/${vehicleType.vehicleType}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setFuelTypeDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setFuelTypeDropdown([]))
        yield put(globalLoaderText(""));
    }
}

function* getEqClassCodeDropdown(): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/eqclass`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setEqClassCodeDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setEqClassCodeDropdown([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogStatusDropdown(): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/filter/status`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setCatalogStatusDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogStatusDropdown([]))
        yield put(globalLoaderText(""));
    }
}

function* getModelYearDropdown(vehicleType: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/filter/modelyear/${vehicleType.vehicleType}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setModelYearDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setModelYearDropdown([]))
        yield put(globalLoaderText(""));
    }
}

function* getDriveTrainDropdown(): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/filter/drivetrain`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setDriveTrainDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setDriveTrainDropdown([]))
        yield put(globalLoaderText(""));
    }
}

function* getVehicleTypeDropdownList(): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdownfilter/vehicle/requestType`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setVehicleTypeDropdownList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setVehicleTypeDropdownList([]))
        yield put(globalLoaderText(""));
    }
}

function* getUpdatedByDropdownList(): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/updatedby`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setUpdatedByDropdownList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUpdatedByDropdownList([]))
        yield put(globalLoaderText(""));
    }
}

function* getAllDropdownBySubtypeId(data: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/assetModel/${data.subTypeId}?isVehicle=${data.isVehicle}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setAllDropdownBySubTypeId(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setAllDropdownBySubTypeId([]))
        yield put(globalLoaderText(""));
    }
}
function* getManufacturerDropdownList(vehicleType: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/filter/manufacturer/${vehicleType.vehicleType}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setManufacturerDropdownList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setManufacturerDropdownList([]))
        yield put(globalLoaderText(""));
    }
}

function* getCategoryDropdownList(vehicleType: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/category/${vehicleType.vehicleType}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setCategoryDropdownList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCategoryDropdownList([]))
        yield put(globalLoaderText(""));
    }
}

function* getLengthDropdownList(vehicleType: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/length/${vehicleType.vehicleType}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setLengthDropdownList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setLengthDropdownList([]))
        yield put(globalLoaderText(""));
    }
}

function* getSeatingCapacityDropdownList(vehicleType: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/seatingcapacity/${vehicleType.vehicleType}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setSeatingCapacityDropdownList(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setSeatingCapacityDropdownList([]))
        yield put(globalLoaderText(""));
    }
}

function* getModelsBasedOnMake(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : req?.type == GET_MODELS_BASED_ON_MAKE ? `catalog/childattribute/${req.make}?attributeName=${AttributeName.MODEL}` : `assets/model/${req.make}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setModelsBasedOnMake(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setModelsBasedOnMake([]))
        yield put(globalLoaderText(""));
    }
}

function* saveCatalogItem(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/catalog`,
            apiMethod : apiMethod.POST,
            payload : req.payload
        }
        yield put(globalLoaderText("Saving Catalog Item...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        if(response){
            yield put(setIsCatalogItemSaved('success'))
        } else {
            yield put(setIsCatalogItemSaved('failed'))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsCatalogItemSaved('failed'))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogItemById(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/assetModel/${req?.assetModelId}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Catalog Item...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        if(response){
            yield put(setCatalogItemByAssetModelId(response))
        } else {
            yield put(setCatalogItemByAssetModelId({}))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogItemByAssetModelId({}))
        yield put(globalLoaderText(""));
    }
}

function* getCategory2ListBasedOnCategory(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `catalog/childattribute/${req?.categoryId}?attributeName=${AttributeName.CATEGORY2}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        if(response){
            yield put(setCategory2BasedOnCategory(response))
        } else {
            yield put(setCategory2BasedOnCategory([]))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCategory2BasedOnCategory([]))
        yield put(globalLoaderText(""));
    }
}

function* getCategoryTypeListBasedOnCategory(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `catalog/childattribute/${req?.categoryId}?attributeName=${AttributeName.CATEGORY_TYPE}`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        if(response){
            yield put(setCategoryTypeBasedOnCategory(response))
        } else {
            yield put(setCategoryTypeBasedOnCategory([]))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCategoryTypeBasedOnCategory([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogDashboardExcelData(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/catalog/${req?.catalogType}/excel`,
            apiMethod : apiMethod.POST,
            payload : req?.payload
        }
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        if(response){
            yield put(setCatalogDashboardExcelData(response))
        } else {
            yield put(setCatalogDashboardExcelData(null))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogDashboardExcelData(null))
        yield put(globalLoaderText(""));
    }
}

function* validateSelectedVehicleLevel(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/validate/vehiclelevel?vehicleLevelIds=${req?.payload}`,
            apiMethod : apiMethod.POST,
            payload : null
        }
        yield put(globalLoaderText("Validating Vehicle Levels...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setIsSelectedVehicleLevelValid(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsSelectedVehicleLevelValid(null))
        yield put(globalLoaderText(""));
    }
}

function* getAssetTypeOptions(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `assets/dropdown/catalog/assettypes`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching Asset Type...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setAssetTypeOption(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setAssetTypeOption([]))
        yield put(globalLoaderText(""));
    }
}

function* getEqClassCodeExample(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `catalog/eqclasscode/category/examples`,
            apiMethod : apiMethod.GET,
            payload : null
        }
        yield put(globalLoaderText("Fetching EQ Class Code Example...."));
        const response = yield call(AssetManagementApiService.post, API_URL.PostWebApp, payloadData );
        yield put(setEqClassCodeExample(response ?? []))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setEqClassCodeExample([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetRequestType() {
    yield takeEvery(GET_CATALOG_MANAGEMENT_GRID_COUNT, getCatalogManagementGridCount)
    yield takeEvery(GET_CATALOG_MANAGEMENT_GRID_DATA, getCatalogManagementGridData)
    yield takeEvery(GET_CATALOG_EQUIPMENT_GRID_DATA, getCatalogEquipmentGridData)
    yield takeEvery(GET_UPFIT_OPTION_DROPDOWN, getUpfitOptionDropdown)
    yield takeEvery(GET_MAKE_DROPDOWN, getMakeDropdown)
    yield takeEvery(GET_MODEL_DROPDOWN_LIST, getModelDropdownList)
    yield takeEvery(GET_FUEL_TYPE_DROPDOWN, getFuelTypeDropdown)
    yield takeEvery(GET_EQ_CLASS_CODE_DROPDOWN, getEqClassCodeDropdown)
    yield takeEvery(GET_CATALOG_STATUS_DROPDOWN, getCatalogStatusDropdown)
    yield takeEvery(GET_MODEL_YEAR_DROPDOWN, getModelYearDropdown)
    yield takeEvery(GET_DRIVE_TRAIN_DROPDOWN, getDriveTrainDropdown)
    yield takeEvery(GET_VEHICLE_TYPE_DROPDOWN_LIST, getVehicleTypeDropdownList)
    yield takeEvery(GET_UPDATED_BY_DROPDOWN_LIST, getUpdatedByDropdownList)
    yield takeEvery(GET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID, getAllDropdownBySubtypeId)
    yield takeEvery(GET_MANUFACTURER_DROPDOWN_LIST, getManufacturerDropdownList)
    yield takeEvery(GET_CATEGORY_DROPDOWN_LIST, getCategoryDropdownList)
    yield takeEvery(GET_LENGTH_DROPDOWN_LIST, getLengthDropdownList)
    yield takeEvery(GET_SEATING_CAPACITY_DROPDOWN_LIST, getSeatingCapacityDropdownList)
    yield takeEvery(GET_MODELS_BASED_ON_MAKE, getModelsBasedOnMake)
    yield takeEvery(GET_EQUIPMENT_MODELS_BASED_ON_MAKE, getModelsBasedOnMake)
    yield takeEvery(SAVE_CATALOG_ITEM, saveCatalogItem)
    yield takeEvery(GET_CATALOG_ITEM_BY_ASSET_MODEL_ID, getCatalogItemById)
    yield takeEvery(GET_CATEGORY2_BASED_ON_CATEGORY, getCategory2ListBasedOnCategory)
    yield takeEvery(GET_CATEGORY_TYPE_BASED_ON_CATEGORY, getCategoryTypeListBasedOnCategory)
    yield takeEvery(GET_CATALOG_DASHBOARD_EXCEL_DATA, getCatalogDashboardExcelData)
    yield takeEvery(VALIDATE_SELECTED_VEHICLE_LEVELS, validateSelectedVehicleLevel)
    yield takeEvery(GET_ASSET_TYPE_OPTIONS, getAssetTypeOptions)
    yield takeEvery(GET_EQ_CLASS_CODE_EXAMPLE, getEqClassCodeExample)
}

export default function* combinedSaga() {
    yield all([
        watchGetRequestType()
    ])
}